import { memo } from 'react';
import TooltipV2 from '@/components/TooltipV2';

interface DisabledOptionTooltipsProps {
  options: { id: string; disabledReason?: string | null }[];
  place?: 'top' | 'bottom' | 'left' | 'right';
}

function DisabledOptionTooltips({ options, place = 'top' }: DisabledOptionTooltipsProps) {
  return (
    <>
      {options
        .filter(option => option.disabledReason)
        .map(option => (
          <TooltipV2
            key={option.id}
            tooltipContent={option.disabledReason || ''}
            containerClassName={'absolute'}
            tooltipId={option.id}
            place={place}
            size="base"
            colorTheme="light"
            className="!px-3 !py-1.5 !text-sm"
            opacity={1}
            offset={12}
          />
        ))}
    </>
  );
}

export default memo(DisabledOptionTooltips);
